// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"7e7fd544","332":"dc27bba8","703":"a83801cf"}[chunkId] + ".chunk.js";
};